// The figures every draw module reads: a full turn, the 0..1 clamp and the
// dash count of a dashed ring.
//
// The recipe kits, the mark painters, the chrome and the audio model each
// carried their own copy. This leaf imports nothing, so a page with no
// engine and a module of `fast/` read the same figure (`fast/nopixi.test.ts`).
// `render/recipe-kit.ts` passes both on to the recipe families.

/** A full turn in radians. */
export const TAU = Math.PI * 2;

/** `v` held to 0..1. NaN stays NaN, as `Math.min(1, Math.max(0, v))` keeps it. */
export function clamp01(v: number): number {
  return v < 0 ? 0 : v > 1 ? 1 : v;
}

/** How many dashes a ring of radius `r` takes at an `[on, off]` pattern in
 *  px: the circumference over one step, rounded, at least 1. A pattern with
 *  no positive step takes 1. */
export function dashesOn(r: number, on: number, off: number): number {
  const step = on + off;
  return step > 0 ? Math.max(1, Math.round((TAU * r) / step)) : 1;
}
